import { createSelector } from 'reselect';

const selectGlobalDbnTaxonomyCategories = (state: any) => state.globalDbnTaxonomyCategories;


export const selectGlobalDbnTaxonomyCategoriesCurrentItem = createSelector([selectGlobalDbnTaxonomyCategories], (globalDbnTaxonomyCategories) => globalDbnTaxonomyCategories.current);

export const selectGlobalDbnTaxonomyCategoriesListItems = createSelector([selectGlobalDbnTaxonomyCategories], (globalDbnTaxonomyCategories) => globalDbnTaxonomyCategories.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalDbnTaxonomyCategoriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalDbnTaxonomyCategoriesQueryItems = createSelector([selectGlobalDbnTaxonomyCategories], (globalDbnTaxonomyCategories) => globalDbnTaxonomyCategories.query);

export const selectGlobalDbnTaxonomyCategoriesCreatedItem = createSelector([selectGlobalDbnTaxonomyCategories], (globalDbnTaxonomyCategories) => globalDbnTaxonomyCategories.create);

export const selectGlobalDbnTaxonomyCategoriesPublishedItem = createSelector([selectGlobalDbnTaxonomyCategories], (globalDbnTaxonomyCategories) => globalDbnTaxonomyCategories.publish);

export const selectGlobalDbnTaxonomyCategoriesCompareItem = createSelector([selectGlobalDbnTaxonomyCategories], (globalDbnTaxonomyCategories) => globalDbnTaxonomyCategories.compare);

export const selectGlobalDbnTaxonomyCategoriesUpdatedItem = createSelector([selectGlobalDbnTaxonomyCategories], (globalDbnTaxonomyCategories) => globalDbnTaxonomyCategories.update);

export const selectGlobalDbnTaxonomyCategoriesReadItem = createSelector([selectGlobalDbnTaxonomyCategories], (globalDbnTaxonomyCategories) => globalDbnTaxonomyCategories.read);

export const selectGlobalDbnTaxonomyCategoriesDeletedItem = createSelector([selectGlobalDbnTaxonomyCategories], (globalDbnTaxonomyCategories) => globalDbnTaxonomyCategories.delete);

export const selectGlobalDbnTaxonomyCategoriesSearchedItems = createSelector([selectGlobalDbnTaxonomyCategories], (globalDbnTaxonomyCategories) => globalDbnTaxonomyCategories.search);

export const selectGlobalDbnTaxonomyCategoriesItemsCount = createSelector([selectGlobalDbnTaxonomyCategories], (globalDbnTaxonomyCategories) => globalDbnTaxonomyCategories.count);

export const selectGlobalDbnTaxonomyCategoriesItemsFilter = createSelector([selectGlobalDbnTaxonomyCategories], (globalDbnTaxonomyCategories) => globalDbnTaxonomyCategories.filter);

export const selectGlobalDbnTaxonomyCategoriesAccountMappingsListItems = createSelector([selectGlobalDbnTaxonomyCategories], (globalDbnTaxonomyCategories) => globalDbnTaxonomyCategories.accountMappingslist);
